import React, { useContext, useEffect, useState } from "react";
import { useForm, useStep } from "react-hooks-helper";

import Success from "pages/Success";
import ChangePasswordPage from "pages/ChangePasswordPage";
import Loading from "components/Loading";
import { Text } from "mondrian-react";
import GenericModal from "components/GenericModal";

const steps = [{ id: "changePassword" }, { id: "success" }];

const defaultData = {};

const AlterarSenha = ({ images }) => {
  const [formData, setForm] = useForm(defaultData);
  const { step, navigation } = useStep({ initialStep: 0, steps });
  const { id } = step;
  const [isLoading, setIsLoading] = useState(false);
  const props = { formData, setForm, navigation, setIsLoading };

  switch (id) {
    case "changePassword":
      return (
        <>
          <Loading isLoading={isLoading} /> <ChangePasswordPage {...props} />
        </>
      );
    case "success":
      return (
        <div>
          <Success {...props} title="Senha alterada com sucesso">
            <Text>
              Agora você pode acessar todos os seus produtos, via site ou app,
              com a senha que acabou de criar.
            </Text>
          </Success>
        </div>
      );
    default:
      return null;
  }
};

export default AlterarSenha;
